import {ResourceProps} from '@refinedev/core';

import {RoleEnum} from '@pages/global/users/user-types';
import {Action} from '@workspaces/access-control-types';
import {resources as BDESEResources} from '@workspaces/bdese/resources';
import {resources as GlobalResources} from '@workspaces/global/resources';
import {resources as PilotageRHResources} from '@workspaces/pilotage-rh/resources';

export type WorkspaceResource = Omit<ResourceProps, 'meta'> & {
  meta: Partial<ResourceProps['meta']> & {
    label: string;
    prefix: string;
    accessControl: Partial<Record<RoleEnum, Partial<Action[]>>>;
  };
};

export const resources: WorkspaceResource[] = [...GlobalResources, ...BDESEResources, ...PilotageRHResources];
